// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Video_wrapper__e_8zG","main":"Video_main__5KiZm"};